module.exports = __webpack_public_path__ + "static/media/save-outline.eb0c5ef2.svg";